import * as React from 'react';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import CustomTable from '../../components/atoms/Table'
import MoreVertIcon from '@mui/icons-material/MoreVert';

import { Box, Button, IconButton, Paper, Switch, Tooltip, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ActionMenu from 'admin/components/atoms/ActionButton';
import service from '../../api/services';
import moment from 'moment';
import SoftBox from 'components/SoftBox';
import BasicModal from 'components/Modal';
import SoftInput from 'components/SoftInput';
import SoftButton from 'components/SoftButton';
import toast from 'react-hot-toast';
import { useAuth } from 'AuthContext';



const User = () => {
  const navigate = useNavigate()
  const [isApiLoading, setIsApiLoading] = React.useState(true)
  const [data, setData] = React.useState([]);
  const [isDone, setDone] = React.useState(false);
  const [comment, setComment] = React.useState("");

  const [show, unShow] = React.useState(false);
  const [userDetail, setUserDetail] = React.useState({});
  const [search, setSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [sortValue, setSortValue] = React.useState({ sortKey: 'name', sortDirection: 'asc' });
  const columns = [
    { id: 'name', label: 'Name', isSorting: true, sortDirection: 'asc', },
    { id: "email", isSorting: true, sortDirection: 'asc', label: "Email" },
    { id: "mobileNumber", isSorting: true, sortDirection: 'asc', label: "Mobile Number" },

    // { id: "business_name", isSorting: true, sortDirection: 'asc', label: "Bussiness Name",render:(row)=>(
    //   <>
    // {row?.merchantId ? row?.merchantId?.businessName : '-'}
    //   </>
    // ) },
    {
      id: 'createdAt', label: 'Created Date', isSorting: true, sortDirection: 'asc', render: (row) => (
        <SoftBox>
          <span>
            {row?.createdAt ? moment(row?.createdAt).format('MM-DD-YYYY') : ''}
          </span>
        </SoftBox>
      )
    },
    {
      id: 'message', label: 'Message', sortDirection: 'asc', isSorting: true, render: (row) => {
        const message = row?.message || '';
        const maxLength = 20;
        const shortMessage = message.length > maxLength ? message.slice(0, maxLength) + '...' : message;

        return (
          <Tooltip title={message} arrow placement="top-start">
            <SoftBox
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '300px', // adjust based on your table width
                cursor: 'pointer',
              }}
            >
              <span>{shortMessage}</span>
            </SoftBox>
          </Tooltip>
        );
      },
    },
    {
      id: 'status',
      label: 'Status', isSorting: true, sortDirection: 'asc',
      render: (row) => (
        <Box display="flex" alignItems="center" gap={1}>
          <Switch color="primary" checked={row.status === 'RESOLVED'} onChange={(i, b) => handleChangeStatus(row._id, b)} />
          <span>{row.status === 'RESOLVED' ? 'RESOLVED' : 'PENDING'}</span>
        </Box>
      )
    },
    {
      id: 'details',
      label: 'Details',
      render: (row) => (
        <ActionMenu
          items={[
            { label: 'Detail', onClick: () => navigate(`/admin/complaint-detail/${row._id}`) },
            // { label: 'Add Comment', onClick: () => { setUserDetail(row); unShow(true) } },
          ]}
        />
      )
    }
  ];

  const getUserDetail = async () => {
    setIsApiLoading(true)
    try {
      setDone(false)
      const response = await service.complaint.view({ type: 'COMPLAINT', searchData: search, page, limit: rowsPerPage, sortKey: sortValue.sortKey, sortDirection: sortValue.sortDirection });
      if (response?.data?.data) {
        setDone(true)

        setData(response.data);
      }
    } catch (error) {
      setDone(true)
      console.error("Failed to fetch business users", error);
    }
    setIsApiLoading(false)
  };

  React.useEffect(() => {
    getUserDetail();
  }, [search, page, rowsPerPage, sortValue]);

  const handleChangeStatus = async (id, type) => {
    try {
      let response = await service.issueReport.updateById(id, { status: type ? 'RESOLVED' : 'OPEN' })
      if (response.status === 201 || response.status === 200) {
        toast.success(response?.data?.message)
        getUserDetail()
      } else {
        toast.error(response?.data?.message)

      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
  const handleSubmit = async () => {
    try {
      const payload = {
        // email: userDetail.email,
        // type: 'REPORT',
        // mobile: userDetail.mobileNumber,
        comment: comment,
      };

      const response = await service.issueReport.comment(userDetail._id, payload);

      if ([200, 201].includes(response.status)) {
        toast.success(response?.data?.message || "Comment submitted successfully");
        setComment("");
        setUserDetail({});
        unShow();
        getUserDetail?.();
      } else {
        toast.error(response?.data?.message || "Failed to submit comment");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <Paper className='glassmorphism-card' sx={{ padding: 2, mt: '15px' }}>
          <CustomTable
            title="All Requests"
            columns={columns}
            rows={data.data}
            search={search}
            setSearch={setSearch}
            page={page}
            // isDone={isDone}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            isApiLoading={isApiLoading}
            totalPages={data?.pagination?.totalItems}
            onRequestSort={(id, direction) => {
              setSortValue({ sortKey: id, sortDirection: direction })
            }}
          />
        </Paper>
      </DashboardLayout>
      <SoftBox>
        <BasicModal
          show={show}
          unShow={unShow}
          title="Resolution Comment"
          width={800}
          height={400}
        >
          <SoftBox sx={{ width: "100%" }}>
            <SoftInput
              multiline
              rows={10}
              placeholder="Type your resolution comment here..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              fullWidth
            />
          </SoftBox>
          <SoftBox display="flex" justifyContent="flex-end" gap={2} mt={3}>
            <SoftButton color="info" variant="gradient" onClick={handleSubmit} disabled={!comment}>
              Submit
            </SoftButton>
          </SoftBox>
        </BasicModal>
      </SoftBox>
    </>
  );
}

export default User
